// eslint-disable-next-line import/no-extraneous-dependencies
import { Card as CardComponent } from "@sunwing/shared-components";
// eslint-disable-next-line import/no-cycle
import { CardAsLink } from "./CardComponents/CardAsLink/CardAsLink";
// eslint-disable-next-line import/no-cycle
import { CardLogo } from "./CardComponents/CardLogo/CardLogo";
// eslint-disable-next-line import/no-cycle
import { CardButton } from "./CardComponents/CardButton/CardButton";
import { CardHeader } from "./CardComponents/CardHeader/CardHeader";
import { CardSubheader } from "./CardComponents/CardSubheader/CardSubheader";
import { CardType } from "./CardComponents/CardType/CardType";
// eslint-disable-next-line import/no-cycle
import { CardSlider } from "./CardComponents/CardSlider/CardSlider";

const Card = CardComponent;

Card.Button = CardButton;
Card.AsLink = CardAsLink;
Card.Logo = CardLogo;
Card.Header = CardHeader;
Card.Subheader = CardSubheader;
Card.Type = CardType;
Card.Slider = CardSlider;

export default Card;
export { Card };
